import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import * as wActs from "../actions/website-actions";
class SideBanners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      max: props.max ? props.max : "2",
      count: props.count ? props.count : "3",
    };
  }

  render() {
    let tmp = this.props.Template;
    let acc = "";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }
    if(acc=="") {
      try { acc = this.props.Website.Request.CountryCode; } catch(ex) {}
    }
    if(acc=="") {
      acc="TR";
    }


    if(this.props.isLeft) {
      return (
        <aside className="aside" style={{minHeight: "1870px"}}>
          <React.Fragment>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x100-sidebar']} className={"newbottom-fbanners"}></SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x200-sidebar']} className={"newbottom-fbanners"}>
                <BuyAdBanner LocalCSS={this.props.Website.Settings.LocalCSS} size={"200x200"} textButton={this.getTranslation("page.advertise.advertisehere")} tagText={this.props.HtmlSections['Adserver-200x200-sidebar']} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x200-featured']} className={"newbottom-fbanners"}></SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc}  tagText={this.props.HtmlSections['Adserver-200x333-sidebar']} className={"newbottom-fbanners"}>
                <BuyAdBanner LocalCSS={this.props.Website.Settings.LocalCSS} size={"200x333"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x333-featured']} className={"newbottom-fbanners"}></SwBanner>
            </div>
          </React.Fragment>
        </aside>
      );

    } else {
      return (
        <aside className="aside" style={{minHeight: "1870px"}}>
          <React.Fragment>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x333-featured']} className={"newbottom-fbanners"}></SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x200-featured']} className={"newbottom-fbanners"}></SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc}  tagText={this.props.HtmlSections['Adserver-200x333-sidebar']} className={"newbottom-fbanners"}>
                <BuyAdBanner LocalCSS={this.props.Website.Settings.LocalCSS} size={"200x333"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x200-sidebar']} className={"newbottom-fbanners"}>
                <BuyAdBanner LocalCSS={this.props.Website.Settings.LocalCSS} size={"200x200"} textButton={this.getTranslation("page.advertise.advertisehere")} tagText={this.props.HtmlSections['Adserver-200x200-sidebar']} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
            <div className={"flex-center"} style={{flexDirection: "column"}}>
              <SwBanner count={this.state.count} maxStandard={this.state.max} apiAnonId={this.props.Website.Request.AnonymousId} country={acc} tagText={this.props.HtmlSections['Adserver-200x100-sidebar']} className={"newbottom-fbanners"}></SwBanner>
            </div>
          </React.Fragment>
        </aside>
      );
    }
  }
  getTranslation(key) {
    return this.props.Website.Translations[key];
  }

}
const mapStateToProps = (state) => {
  return {
    Website: state.Website,
    PageType: state.Website.PageType,
    HtmlSections: state.Website.Settings.HtmlSections,
    Template: state.Website.Page.Template
  };
}

export default connect(mapStateToProps)(SideBanners);
